import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import Navbar from "./components/NavBar";
import Home from "./containers/Home";
import Marketplace from "./containers/Marketplace";
import Login from "./containers/Login";
import Signup from "./containers/Signup";
import SignupClient from "./containers/Signup/Client";
import SignupEntrepreneur from "./containers/Signup/Entrepreneur";
import Product from "./containers/Marketplace/Product";
import Terms from "./containers/Terms";
import NotFound from "./containers/NotFound";
import Store from "./containers/Marketplace/Store";
import FloatingCart from "./components/FloatingCart";
import NewPassword from "./containers/Password/NewPassword";
import ForgotPassword from "./containers/Password/ForgotPassword";
import Purchases from "./containers/Purchases";
import Account from "./containers/Account";
import Entrepreneur from "./containers/Entrepreneur";
import EntDashboard from "./containers/Entrepreneur/Dashboard";
import EntOrders from "./containers/Entrepreneur/Orders";
import EntProducts from "./containers/Entrepreneur/Products";
import EntGiftvoucher from "./containers/Entrepreneur/Giftvoucher";
import Admin from "./containers/Admin";
import AdminDashboard from "./containers/Admin/Dashboard";
import AdminUsers from "./containers/Admin/Users";
import AdminPayments from "./containers/Admin/Payments";
import AdminLocations from "./containers/Admin/Locations";
import AdminCategories from "./containers/Admin/Categories";
import AdminRibbonBadges from "./containers/Admin/ribbonBadges";
import AdminTypesCategories from './containers/Admin/typesCategories';
import AdminPartner from './containers/Admin/partners';
import AdminBanner from './containers/Admin/banners';
import AdminProducts from './containers/Admin/products';
import AdminLeads from "./containers/Admin/Leads";
import AdminPromotions from "./containers/Admin/Promotions";
import AdminAutomation from "./containers/Admin/Automation";
import AdminMessageHistory from "./containers/Admin/MessageHistory";
import Contact from "./containers/Contact";
import ConfirmTerms from "./components/ConfirmTerms";
import Checkout from "./containers/Checkout";
import EntConfPayment from "./containers/Entrepreneur/ConfirmPayment";
import EntLoyaltyCards from "./containers/Entrepreneur/LoyaltyCards";
import LoyaltyCards from "./containers/LoyaltyCards";
import Voucher from "./containers/Marketplace/Voucher";
import PrivateRoute from "./providers/PrivateRouteProvider";
import AddProductPage from "./containers/AddProductPage/AddProductPage";
import AddProductAssistantPage from "./containers/AddProductAssistantPage";
import { GruposGeral, GruposCelular, GruposXiaomi, GruposSamsung, GruposMotorola, GruposApple, GruposHiperfoco } from "./containers/Admin/GruposAdmin/GruposAdmin";
import Grupos from "./containers/Grupos";
import ProductRequestForm from "./containers/ProductRequestForm";

export default function Routes() {
  return (
    <BrowserRouter>
      <Navbar />
      {/* TODO: Page Tracking GA */}

      <Switch>
        {/* <Route exact path="/" component={Home} /> */}

        {/*<PrivateRoute exact path="/" component={Marketplace} />*/}
        <Route exact path="/" component={Marketplace} />
        {/*<Route exact path="/adicionar-oferta" component={AddProductPage} />*/}
        <Route exact path="/adicionar-oferta-ia" component={AddProductAssistantPage} />
        <Route path="/sobre" component={Home} />
        <Route path="/entrar" component={Login} />
        <Route path="/cadastro/cliente" component={SignupClient} />
        <Route path="/cadastro/empreendedor" component={SignupEntrepreneur} />
        <Route path="/cadastro" component={Signup} />
        <Route path="/recuperar" component={ForgotPassword} />
        <Route path="/redefinir/:token" component={NewPassword} />
        <Route path="/conta" component={Account} />
        <Route path="/checkout" component={Checkout} />
        <Route path="/produto/:id" component={Product} />
        <Route path="/giftvoucher/:id" component={Voucher} />
        <Route path="/loja/:id" component={Store} />
        <Route path="/categoria/:idCategory" component={Marketplace} />
        <Route path="/subCategory/:subCat" component={Marketplace} />
        {/* <Route path="/marketplace/" component={Marketplace} /> */}
        {/* Pedir Produto desativado temporariamente - reativar quando ferramenta voltar */}
        {/* <Route path="/pedir-produto" component={ProductRequestForm} /> */}
        {/* <Route path="/parceiros" component={ProductRequestForm} /> */}
        <Route path="/grupos/" component={Grupos} />
        <Route path="/compras" component={Purchases} />
        <Route path="/fidelidade" component={LoyaltyCards} />
        <Route path="/politica-privacidade" component={Terms} />
        <Route path="/contato" component={Contact} />
        <Route path="/poster/fidelidade" component={EntLoyaltyCards} />
        <Route path="/poster/dashboard" component={EntDashboard} />
        <Route path="/poster/pedidos" component={EntOrders} />
        <Route path="/poster/produtos" component={EntProducts} />
        <Route path="/poster/giftvoucher" component={EntGiftvoucher} />
        <Route path="/poster/pedido/:id" component={EntConfPayment} />
        <Route exact path="/poster/leads" render={() => <Redirect to="/poster/leads/overview" />} />
        <Route path="/poster/leads/:section(overview|insights|management)" component={AdminLeads} />
        <Route path="/poster/promocoes" component={AdminPromotions} />
        <Route path="/poster/automacao-whatsapp" component={AdminAutomation} />
        <Route path="/poster/historico-mensagens" component={AdminMessageHistory} />
        <Route path="/poster" component={Entrepreneur} />
        <Route path="/admin/dashboard" component={AdminDashboard} />
        <Route path="/admin/usuarios" component={AdminUsers} />
        <Route path="/admin/pagamentos" component={AdminPayments} />
<Route path="/admin/grupos-geral" component={GruposGeral} />
<Route path="/admin/grupos-celular" component={GruposCelular} />
<Route path="/admin/grupos-xiaomi" component={GruposXiaomi} />
<Route path="/admin/grupos-samsung" component={GruposSamsung} />
<Route path="/admin/grupos-motorola" component={GruposMotorola} />
<Route path="/admin/grupos-apple" component={GruposApple} />
<Route path="/admin/grupos-hiperfoco" component={GruposHiperfoco} />

        <Route path="/admin/localidades" component={AdminLocations} />
        <Route path="/admin/categorias" component={AdminCategories} />
        <Route path="/admin/ribbon-badges" component={AdminRibbonBadges} />
        <Route path="/admin/tipos-categorias" component={AdminTypesCategories} />
        <Route path="/admin/parceiros" component={AdminPartner} />
        <Route path="/admin/banner" component={AdminBanner} />

        <Route path="/admin/products" component={AdminProducts} />
        <Route exact path="/admin/leads" render={() => <Redirect to="/admin/leads/overview" />} />
        <Route path="/admin/leads/:section(overview|insights|management)" component={AdminLeads} />
        <Route path="/admin/promocoes" component={AdminPromotions} />
        <Route path="/admin/automacao-whatsapp" component={AdminAutomation} />
        <Route path="/admin/historico-mensagens" component={AdminMessageHistory} />
        <Route path="/admin" component={Admin} />
        <Route component={NotFound} />
      </Switch>
      <ConfirmTerms />
    </BrowserRouter>
  );
}
